import { AxiosResponse } from 'axios';
import { ActCategory } from 'shell/models/act-category-list';
import { HttpResponse } from 'shell/models/http-response';
import { RegistrationCivilUnionFormVM } from 'mutation/view-models/registration-civil-union';
import { transformEditDataControl } from './transform-edit-data-control';
import { transformCivilUnionAccordion } from './transform-civil-union-accordion';
import { checkError, formatErrorMunicipalityForeign } from '../transform-family-detail/check-error';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';

export const transformCivilUnion = (
  response: AxiosResponse<HttpResponse<ActCategory>>,
  isMaritoResidenceMilano?: boolean
): { data: RegistrationCivilUnionFormVM; error?: string } => {
  const castedRes = response.data.payload.consultazioneANSCResponse?.modelEventoDTO || [];
  const modelEventoDTO = castedRes[0] || {};

  const castedDatiAggiuntiviSide = response.data.payload.datiAggiuntiviSide || {};
  const intestatari = castedDatiAggiuntiviSide.intestatariTranscod || [];

  const editDataControl = transformEditDataControl(modelEventoDTO);
  const civilUnion = transformCivilUnionAccordion(
    isMaritoResidenceMilano ? intestatari[1] : intestatari[0],
    modelEventoDTO,
    castedDatiAggiuntiviSide
  );

  const errorIntestatario1: string = checkError(intestatari[0]);
  const errorIntestatario2: string = checkError(intestatari[1]);

  let errorCivilUnion;

  const isForeign =
    castedDatiAggiuntiviSide?.luogoCelebrazioneTranscod &&
    castedDatiAggiuntiviSide?.luogoCelebrazioneTranscod?.idStato !== CODE_STATE_ITALIAN;

  if (isForeign && !castedDatiAggiuntiviSide.luogoCelebrazioneTranscod?.idComune) {
    errorCivilUnion = formatErrorMunicipalityForeign(
      castedDatiAggiuntiviSide.luogoCelebrazioneTranscod?.comuneEstero,
      castedDatiAggiuntiviSide.luogoCelebrazioneTranscod?.nomeStato
    );
  }

  return {
    data: {
      editDataControl,
      civilUnion,
    },
    error: errorIntestatario1 || errorIntestatario2 || errorCivilUnion,
  };
};
